export enum PLANS {
  STARTER_FREE = 'starter_free',
  STARTER_PREMIUM = 'starter_premium',
  ESSENTIALS = 'essentials',
  PERFORMANCE = 'performance',
  ENTERPRISE = 'enterprise',
}
